module.exports = __webpack_public_path__ + "static/media/deyy.2feabd4e.mp4";